import { ReactComponent as NotFoundImage } from 'assets/not_found.svg';
import { Box, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FerramentasDeDetalhe } from 'shared/components';
import { LayoutBaseDePagina } from 'shared/layouts';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <LayoutBaseDePagina
      titulo={'Página não encontrada'}
      barraDeFerramentas={(
        <FerramentasDeDetalhe
          idForm='formDetalheDeWorkflow'
          mostrarBotaoNovo={false}
          mostrarBotaoApagar={false}
          mostrarBotaoGenerico={false}
          mostrarBotaoSalvar={false}

          aoClicarEmVoltar={() => navigate(-1)}
        />)
      }
    >
      <Box component={Paper} 
        variant="outlined" 
        flexDirection="column"
        sx={{ 
          m: 1, 
          width: 'auto', 
          display: 'flex',
          flexWrap: 'wrap'
        }}>
        <NotFoundImage height={400} fill="#4788C7" stroke="#DFF0FE" />
        <Typography
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipses"
          variant={'h5'}
          align='center'
          marginBottom={16}
        >
          A página solicitada não foi encontrada!
        </Typography>
      </Box >
    </LayoutBaseDePagina >
  );
};